import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../../services/language.service';
import { SelectItem } from 'primeng-lts/api';

@Component({
  selector: 'lang-selection',
  templateUrl: './lang-selection.component.html'
})
export class LangSelectionComponent implements OnInit {

  public languages: SelectItem[];
  public currentLanguage: string;

  constructor(private languageService: LanguageService) { }

  ngOnInit() {
    this.languages = [];
    let avaliableLang = this.languageService.getAvaliableLanguages();
    avaliableLang.forEach((lang: string) => {
      let item = {} as SelectItem;
      item.value = lang;
      this.languages.push(item);
    })
    this.currentLanguage = this.languageService.getAppLanguage();
  }

  public changeLanguage(event: { originalEvent: Event, value: string }): void {
    this.languageService.setUserLanguage(event.value);
    this.languageService.changeAppLanguage(event.value);
  }
}
